<template>
  <div class="v-application">
    <div class="flex-column mx-0 pa-4 mt-4">
      <div class="text-h5 text-center relative">
        {{ $city.name }}政府衛生局
        <div class="fixed-number">
          <div class="text-h5 text-decoration-underline font-weight-bold"></div>
          報到號碼：{{ 報到號碼 }}
          <div class="text-h6">建議報到時間 {{ person.建議時間 }}</div>
        </div>
      </div>
      <div class="text-h6 text-center">整合式篩檢 全民健檢</div>

      <v-row class="mt-0">
        <v-col cols="3" class="text-h6 pb-0">姓名：{{ person.姓名 }}</v-col>
        <v-col cols="3" class="text-h6 pb-0 text-center">
          年齡：{{ 年齡 }} 歲
        </v-col>
        <v-col cols="2" class="text-h6 pb-0 text-center">
          性別：{{ 性別 }}
        </v-col>
        <v-col cols="4" class="text-h6 pb-0 text-right">
          電話：{{ person.電話 }}
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-card elevation="0" class="card mb-0 pb-0">
            <v-card-title class="justify-center pa-1">參加意願書</v-card-title>
            <v-card-text
              class="text-body-1 font-weight-bold"
              style="position: relative"
            >
              本人願意接受{{
                $city.name
              }}政府衛生局辦理之整合式篩檢全民健檢，並在不影響個人隱私權之下，同意將篩檢服務所得資料做為衛生單位健康管理之用。本人亦願意在衛生單位許可下提供血液等檢體及個人資料與相關資料庫進行連結。
              <div
                class="text-right"
                style="position: absolute; right: 20px; bottom: 0px"
              >
                <span class="mr-16">參加者：</span>
                <span class="ml-16">(簽名)</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="8">
          <table class="table">
            <tr class="font-weight-bold">
              <th>項 目</th>
              <th>結 果</th>
              <th>
                檢查人員簽章
                <div class="text-body-2">(全名)</div>
              </th>
            </tr>
            <tr class="font-weight-bold" v-for="item of list">
              <td>{{ item }}</td>
              <td class="text-center px-0">
                <div
                  v-if="
                    (item == '口腔黏膜檢查' && !person.篩檢項目.口腔) ||
                    (item == '糞便潛血檢查' && !person.篩檢項目.大腸) ||
                    (item == '子宮頸抹片檢查' && !person.篩檢項目.子抹) ||
                    (item == '乳房攝影檢查' && !person.篩檢項目.乳攝)
                  "
                >
                  本次不含
                </div>
                <div
                  v-else-if="
                    item == '口腔黏膜檢查' ||
                    item == '子宮頸抹片檢查' ||
                    item == '乳房攝影檢查'
                  "
                  class="d-flex justify-center bg-gray"
                >
                  <v-checkbox label="檢查" dense hide-details></v-checkbox>
                  <v-checkbox label="未檢查" dense hide-details></v-checkbox>
                </div>
                <div
                  v-else-if="item == '尿液檢查' || item == '糞便潛血檢查'"
                  class="d-flex justify-center bg-gray"
                >
                  <v-checkbox label="發管" dense hide-details></v-checkbox>
                  <v-checkbox label="未發管" dense hide-details></v-checkbox>
                </div>
                <div v-else class="d-flex justify-start">
                  <v-checkbox label="完成" dense hide-details></v-checkbox>
                  <v-checkbox label="未完成" dense hide-details></v-checkbox>
                </div>
                <div class="fill-number" v-if="item == '胸部X光肺結核篩檢'">
                  號碼：＿＿＿＿＿
                </div>
              </td>
              <td></td>
            </tr>
          </table>
        </v-col>
        <v-col cols="4" class="text-center">
          <div class="text-h6">{{ person.日期 }}</div>
          <div class="text-h6">{{ person.地點 }}</div>
          <v-alert outlined dense color="success" text class="text-h5 mt-4">
            檢驗站掃描碼
          </v-alert>
          <div class="d-flex justify-center border-white">
            <qrcode-vue :value="person._id" size="133" level="Q"></qrcode-vue>
          </div>
          <v-alert
            outlined
            dense
            color="success"
            text
            class="text-h5 mt-6"
            v-if="!person.report[0].外部問卷"
          >
            掃碼填寫問卷
          </v-alert>
          <div
            class="d-flex justify-center border-white"
            v-if="!person.report[0].外部問卷"
          >
            <qrcode-vue :value="qrcode" size="133" level="Q"></qrcode-vue>
          </div>
          <v-alert
            outlined
            dense
            color="success"
            text
            class="text-h5 mt-6"
            v-if="surveySatisfactionURL && !person.report[0].滿意問卷"
          >
            滿意度問卷
          </v-alert>
          <div
            class="d-flex justify-center border-white"
            v-if="surveySatisfactionURL && !person.report[0].滿意問卷"
          >
            <qrcode-vue
              :value="qrcodeSatisfaction"
              size="133"
              level="Q"
            ></qrcode-vue>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import util from "@/mixins/util";
import dayjs from "dayjs";
import { surveyURL, surveySatisfactionURL } from "@/../env.js";
export default {
  name: "PageTitle",
  mixins: [util],
  components: {
    QrcodeVue,
  },
  props: ["person"],
  data: () => ({
    list: [
      "掛號",
      "問卷",
      "口腔黏膜檢查",
      "發早餐",
      "抽血檢查",
      "胸部X光肺結核篩檢",
      "糞便潛血檢查",
      "尿液檢查",
      "醫師理學檢查",
      "子宮頸抹片檢查",
      "乳房攝影檢查",
      "滿意度調查",
    ],
  }),
  computed: {
    qrcode() {
      return `${surveyURL}?aka_name=${this.person.姓名}&aka_id=${this.person.身分證字號}`;
    },
    qrcodeSatisfaction() {
      return `${surveySatisfactionURL}?aka_id=${this.person.身分證字號}`;
    },
    報到號碼() {
      return _.padStart(this.person.報到號碼, 4, "0");
    },
    年齡() {
      let birth = parseInt(this.person.出生年月日) + 19110000 + "";
      return dayjs().year() - dayjs(birth).year();
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: 6px double #000;
  border-radius: 0;
}
table,
th,
td {
  font-size: 18px;
  border: 2px solid black;
  border-collapse: collapse;
}
tr {
  height: 60px;
}
td,
th {
  padding: 0 12px 0 12px;
}
::v-deep .v-icon.v-icon {
  font-size: 35px;
  color: #000;
}
::v-deep .v-input--selection-controls {
  margin: 0 4px;
}
::v-deep .v-label {
  color: #000;
}
::v-deep .v-input--selection-controls__input {
  margin-right: 4px;
}
::v-deep .v-input--selection-controls {
  padding-top: 0;
  margin-top: 0;
}
.qr-wrap {
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.relative {
  position: relative;
}
.fixed-number {
  position: absolute;
  top: 0;
  right: 0;
}
.fill-number {
  position: relative;
  top: 7px;
}
.border-white {
  border: 1px solid #fff;
}
</style>
